<template>
  <div class="credential-info">
    <h1 class="form-title">{{ $t('APP-FIELD-0109') }}</h1>
    <p class="tip">{{ $t('APP-FIELD-0110') }}</p>
    <div class="userid-box">
      <p v-if="type === 'userId'">Your User ID is<br/><br/> {{ value }}</p>
      <p v-if="type === 'password'">Your Temporary Password is<br/><br/> {{ value }}</p>
    </div>
    <SaveImage @on-click="onSaveImg"></SaveImage>
  </div>
</template>

<script>
import SaveImage from "./SaveImage";

export default {
  name: "TwoPageCredentials",
  props: ['type', 'value'],
  components: {
    SaveImage
  },
  data() {
    console.log(this.$props.type)
    return {};
  },
  methods: {
    onSaveImg() {
      // 调用app截屏
      this.takeAppSrceenShort();
    }
  }
}
</script>

<style lang="scss" scoped>
.credential-info {

  .tip {
    text-align: left;
  }

  .userid-box {
    width: 327px;
    height: 87px;
    background: #a4c7ec;
    margin: 30px auto 32px;
  }
}
</style>